var site = site || {};
(function($) {
  Drupal.behaviors.trendReportTrueFalseV1 = {
    attach: function(context) {
      var $module = $('.js-trend-report-true-false', context);
      var $truefalseBtn = $module.find('.js-trend-report-truefalse__cta');
      var $truefalseAns = $module.find('.js-trend-report-truefalse__answer');

      function fireAnalytic(eventAction, eventLabel) { // GA
        if (site && site.track) {
          site.track.evtLink({
            event_name: 'elTrueFalseQuiz',
            event_category: 'True False Quiz',
            event_action: eventAction,
            event_label: eventLabel
          });
        }
      }

      $truefalseBtn.off('click.answerBtn').on('click.answerBtn', function() {
        $truefalseAns.addClass('trend-report-truefalse__answer--show');
        if ($truefalseAns.hasClass('js-trend-report-truefalse__cta-true') === true) {
          fireAnalytic('Answer', 'True');
        } else if ($truefalseAns.hasClass('js-trend-report-truefalse__cta-false') === true) {
          fireAnalytic('Answer', 'False');
        }
      });
    }
  };
})(jQuery);
